import { inject, makeStateKey, TransferState } from '@angular/core';
import { PlatformService } from '@rma/public/generic/util/environment';
import { Observable, of, tap } from 'rxjs';

export type TransferOnce = <T>(key: string, request$: Observable<T>) => Observable<T>;

// The HTTP transfer cache stops serving once the app is stable, but a request made when a hydrate block fires
// later must still resolve synchronously or Angular discards the server markup. The server's response is
// handed over through TransferState instead and read back once.
export function injectTransferOnce(): TransferOnce {
  const transferState = inject(TransferState);
  const platformService = inject(PlatformService);

  return <T>(key: string, request$: Observable<T>): Observable<T> => {
    const stateKey = makeStateKey<T>(key);
    const transferred = transferState.get<T | null>(stateKey, null);
    if (transferred !== null) {
      transferState.remove(stateKey);
      return of(transferred);
    }

    return request$.pipe(
      tap((value) => {
        if (platformService.isPlatformServer && value != null) {
          transferState.set(stateKey, value);
        }
      }),
    );
  };
}
